export enum SanctionFieldCode {
	Roik = 1,
	Document = 2,
	FineAmount = 3,
	PaymentDueDate = 4,
	PaymentDate = 5,
	SuspensionStartDate = 6,
	ProhibitionStartDate = 7,
	RenewalDate = 8,
	Products = 9,
	Animals = 10,
	Notes = 11,
	IsAppealed = 12,
	PersonCode = 13,
}
